'use es6';

import isEqual from 'hs-lodash/isEqual';
import { NavMarker } from 'react-rhumb';
import { connect as connectFlux } from 'general-store';
import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { createRef, Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import compose from 'transmute/compose';
import pick from 'transmute/pick';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import bust from 'reporting-data/bust';
import { withDialog } from 'reporting-action-components/dialog/DialogProvider';
import { CUSTOM_DASHBOARD_COUNT, CUSTOM_DASHBOARD_LIMIT, DASHBOARD_CREATED_AT_TIMESTAMP, DASHBOARD_IS_CUSTOM, DASHBOARD_IS_LOADING, IS_READ_ONLY_DEMO, MAX_USER_ASSET_PERMISSION, USER_DASHBOARD_PERMISSION } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import { isNil } from 'dashboard-lib/private/js-util';
import { defer } from 'dashboard-lib/private/js-util';
import { getCreatedAt, getName, getTemplate, getUpdatedAt, getWidgetCount } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { canRenameDashboard } from 'dashboard-lib/public/enable-action/rename-dashboard';
import { canSetDashboardPermission } from 'dashboard-lib/public/enable-action/set-dashboard-permission';
import { fetchDashboardSentenceSingle } from 'dashboard-lib/public/permission/permission-action';
import { AssetPermissionTypes } from 'dashboard-lib/public/permission/asset-permission';
import { selectDashboardPermission, selectDashboardPermissionConfigStatus } from 'dashboard-lib/public/permission/permission-selector';
import { isCustomDashboard, isReadOnlyDemo, isValidDashboardString } from 'dashboard-lib/public/dashboard/dashboard-logic';
import { DASHBOARD_RENAME, DASHBOARD_SET_PERMISSION } from 'dashboard-lib/public/action/reporting-action';
import { selectUserMaxAssetPermission } from 'dashboard-lib/public/userInfo/permissions';
import { selectHasDashboardDemoWriteScope, selectIsFreeOrStarterUser } from 'dashboard-lib/public/userInfo/scopes';
import { selectUserId } from 'dashboard-lib/public/userInfo';
import { track as dashboardUITracker, EVENTS } from 'dashboard-ui-components/tracking/DashboardUITracker';
import { fetchDashboard, updateDashboardMeta } from '../../actions/DashboardActions';
import { parseAsQueryMap } from '../../lib/historyUtils';
import DashboardStore from '../../stores/DashboardStore';
import PortalSettingsStore from '../../stores/PortalSettingsStore';
import SettingsStore from '../../stores/SettingsStore';
import { withDashboardPermission } from '../../decorators/withDashboardPermission';
import { CustomReportCountDependency, DashboardCountDependency } from '../../dependencies/DashboardsDependency';
import { AsyncGrowthModalContainer } from '../pql/AsyncAddonUpgrades';
import EngagementTracker from '../shared/EngagementTracker';
import WidgetGridContainer from './WidgetGridContainer';
import TimeZoneMessage from './TimeZoneMessage';
import Header from './header/Header';
import SubHeader from './header/SubHeader';
import DashboardBanners from './DashboardBanners';
import { USER_ATTRIBUTES_KEYS } from '../../data/UserAttributesDAO';
import { requestFullScreen, setFullScreenHandler, isFullScreen, exitFullScreen } from '../../lib/FullScreenHelpers';
import { DashboardFloatingAlertStore } from 'dashboard-components/shared/DashboardFloatingAlertStore';
import PresentationMode from './PresentationMode';
import { INCREMENT_FORCE_RENDER_COUNT } from '../../ducks/forceRenderCount';
import { getRecentlyViewedDisplayCount } from 'dashboard-components/lib/urlHelpers';
// TO DO: Remove recordRecentDashboard once IA is fully released
import { recordRecentDashboard } from 'dashboard-components/dashboard-actions/lib/recentDashboardsStorage';
import { parseQueryString, removeKeyFromQueryString } from '../../lib/queryUtils';
import { AsyncSingleReportViewerContainer as SingleReportViewerContainer } from './AsyncSingleReportViewerContainer';
import { getPathParams } from 'dashboard-ui-components/lib/routerUtils';
import { getWidgetWithReportId } from 'dashboard-lib/public/dashboard/dashboard-logic';
import { getReport } from 'dashboard-lib/public/widget/widget-schema';
import { getContactCount, selectContactCount } from '../../ducks/contactCount';
import { ResurrectionBannerExperiment } from '../experiments/res0010/ResurrectionBannerExperiment';
import { AsyncDiscoveryDashboardContainer as DiscoveryDashboardContainer } from '../discovery/AsyncDiscoveryDashboardContainer';
import { selectHasDashboardPanelAccess } from 'dashboard-lib/public/userInfo/gates';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isActiveTab = () => document.visibilityState !== 'hidden';
const getMonthsSinceToday = time => I18n.moment.portalTz().diff(I18n.moment.portalTz(time), 'months');
const FullScreenModeContainer = styled.div.withConfig({
  displayName: "Dashboard__FullScreenModeContainer",
  componentId: "sc-1ketl9n-0"
})(["height:100%;&:fullscreen{overflow:auto !important;}&:-ms-fullscreen{overflow:auto !important;}&:-webkit-full-screen{overflow:auto !important;}&:-moz-full-screen{overflow:auto !important;}"]);
const WrappedEngagementTracker = ({
  dashboard
}) => dashboard ? /*#__PURE__*/_jsx(EngagementTracker, {
  data: {
    widgetCount: getWidgetCount(dashboard)
  }
}) : null;
const ADD_REPORT_SUCCESS_REFRESH_PARAM = 'isAddReportSuccess';

// While we work on consolidating the apps, data, and actions from the old experience
// to the new IA experience, query params will be used to force inter 'componentized' app
// action dispatches. This case will force the dashboard to refetch the widgets when a report
// has been successfully added from the reports-list flow
const isAddReportSuccess = () => {
  const queryParams = parseQueryString(window.location.search);
  return queryParams[ADD_REPORT_SUCCESS_REFRESH_PARAM];
};
class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.handleFullScreenChange = () => {
      const {
        dashboardFullScreenRequested
      } = this.state;
      if (!isFullScreen()) {
        this.setState({
          isPresentationMode: false
        });
      }
      // ensures that it wasn't a widget (iframe) that requested full screen
      else if (dashboardFullScreenRequested) {
        this.setState({
          dashboardFullScreenRequested: false,
          isPresentationMode: true
        });
      }
    };
    this.enterPresentationMode = () => {
      requestFullScreen(this.fullScreenEle.current);
      this.setState({
        dashboardFullScreenRequested: true
      });
    };
    this.updateDashboard = () => {
      const {
        dashboardId
      } = this.props;
      if (isActiveTab()) {
        fetchDashboard(dashboardId);
        bust();
        this.props.incrementForceRenderCount();
      }
    };
    this.renderWidgetGrid = () => {
      const {
        dashboard
      } = this.props;
      let widgetCount;
      if (!dashboard) {
        return null;
      } else {
        widgetCount = dashboard.get('widgetCount');
      }
      const passThroughProps = pick(['dashboard', 'errored', 'rendered', 'fetched'], this.props);
      return /*#__PURE__*/_jsx(WidgetGridContainer, Object.assign({}, passThroughProps, {
        widgetCount: widgetCount
      }));
    };
    this.renderFullScreenDashboard = () => {
      const {
        dashboard,
        dashboardId
      } = this.props;
      return /*#__PURE__*/_jsx(PresentationMode, {
        dashboard: dashboard,
        dashboardId: dashboardId,
        exitPresentationMode: exitFullScreen
      });
    };
    this.render = () => {
      const {
        dashboard,
        dashboardLocked,
        customDashboardCount,
        match,
        hasDashboardPanelAccess
      } = this.props;
      const {
        isPresentationMode
      } = this.state;
      const {
        reportId: reportIdFromPath
      } = getPathParams(match);
      const reportId = Number(reportIdFromPath);
      const report = getReport(getWidgetWithReportId(dashboard, reportId));
      const dashboardContent = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AsyncGrowthModalContainer, {
          app: "reporting"
        }), /*#__PURE__*/_jsx(DashboardBanners, {
          customDashboardCount: customDashboardCount
        }), /*#__PURE__*/_jsx(ResurrectionBannerExperiment, {}), /*#__PURE__*/_jsx(SubHeader, {
          dashboard: dashboard
        }), this.renderWidgetGrid(), report && /*#__PURE__*/_jsx(NavMarker, {
          name: "SRV_LOADED",
          children: /*#__PURE__*/_jsx(SingleReportViewerContainer, {
            report: report,
            dashboard: dashboard
          })
        }), /*#__PURE__*/_jsx(TimeZoneMessage, {})]
      });
      const renderDashboard = () => {
        if (hasDashboardPanelAccess) {
          return /*#__PURE__*/_jsx(DiscoveryDashboardContainer, {
            dashboard: dashboard,
            dashboardLocked: dashboardLocked,
            enterPresentationMode: this.enterPresentationMode,
            children: dashboardContent
          });
        }
        return /*#__PURE__*/_jsx(UIDashboardPage, {
          "data-test-id": "dashboard-container",
          headerComponent: /*#__PURE__*/_jsx(Header, {
            dashboard: dashboard,
            dashboardLocked: dashboardLocked,
            enterPresentationMode: this.enterPresentationMode
          }),
          pageLayout: "full-width",
          children: dashboardContent
        });
      };
      return /*#__PURE__*/_jsx(FullScreenModeContainer, {
        ref: this.fullScreenEle,
        children: isPresentationMode ? this.renderFullScreenDashboard() : /*#__PURE__*/_jsxs(Fragment, {
          children: [renderDashboard(), /*#__PURE__*/_jsx(WrappedEngagementTracker, {
            dashboard: dashboard
          }), /*#__PURE__*/_jsx(FloatingAlertList, {
            alertStore: DashboardFloatingAlertStore,
            use: "contextual"
          })]
        })
      });
    };
    Raven.setExtraContext({
      dashboardId: this.props.dashboardId
    });
    this.state = {
      dashboardFullScreenRequested: false,
      isPresentationMode: false
    };
    setFullScreenHandler(this.handleFullScreenChange);
    this.fullScreenEle = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const {
      dashboardId,
      history,
      fetchPermission,
      userId,
      fetchContactCount,
      isFreeOrStarterUser
    } = this.props;
    fetchPermission({
      dashboardId,
      userId
    });
    if (isFreeOrStarterUser) {
      fetchContactCount();
    }
    recordRecentDashboard(dashboardId, getRecentlyViewedDisplayCount());
    this.interval = setInterval(this.updateDashboard, 600000);
    window.addEventListener('online', this.updateDashboard);
    if (isAddReportSuccess()) {
      this.updateDashboard();
      // Defer updating history, otherwise an error will appear from dispatching within a dispatch
      defer(() => removeKeyFromQueryString(history, ADD_REPORT_SUCCESS_REFRESH_PARAM));
    }
  }
  componentDidUpdate(prevProps) {
    const {
      canWriteDemoDashboard,
      customDashboardCount,
      customDashboardLimit,
      dashboard,
      dashboardPermission,
      dashboardPermissionConfigStatus,
      userAttributes,
      userAttributesLoaded,
      history,
      dashboardId,
      fetched,
      fetchPermission,
      maxUserAssetPermission,
      showDialog,
      userId
    } = this.props;
    const {
      dashboard: prevDashboard
    } = prevProps;
    const contextParams = parseAsQueryMap(history);
    const dashboardUpdated = !isEqual(prevDashboard.toJS(), dashboard.toJS());
    if (dashboardUpdated) {
      fetchPermission({
        dashboardId,
        userId
      });
      this.hasTrackedDashboardView = false;
    }
    const canRenameDashboardValue = canRenameDashboard({
      [DASHBOARD_IS_LOADING]: !dashboard,
      [USER_DASHBOARD_PERMISSION]: dashboardPermission,
      [MAX_USER_ASSET_PERMISSION]: maxUserAssetPermission,
      [CUSTOM_DASHBOARD_COUNT]: 0,
      [CUSTOM_DASHBOARD_LIMIT]: 1,
      [DASHBOARD_CREATED_AT_TIMESTAMP]: 0,
      [DASHBOARD_IS_CUSTOM]: isCustomDashboard(dashboard),
      [IS_READ_ONLY_DEMO]: isReadOnlyDemo(canWriteDemoDashboard, dashboard)
    });
    const hasArrivedFromRequestAccessCTA = !isNil(dashboard) && ImmutableMap.isMap(dashboard) && contextParams.assignPermissions === 'true' && dashboardPermissionConfigStatus === 'SUCCEEDED' && (!this.state || !this.state.setPermissionDialogIsOpen);
    if (hasArrivedFromRequestAccessCTA) {
      const canSetDashboardPermissionValues = canSetDashboardPermission({
        [USER_DASHBOARD_PERMISSION]: dashboardPermission,
        [DASHBOARD_IS_CUSTOM]: isCustomDashboard(dashboard),
        [DASHBOARD_CREATED_AT_TIMESTAMP]: getCreatedAt(dashboard),
        [CUSTOM_DASHBOARD_COUNT]: customDashboardCount,
        [CUSTOM_DASHBOARD_LIMIT]: customDashboardLimit,
        [MAX_USER_ASSET_PERMISSION]: maxUserAssetPermission,
        [IS_READ_ONLY_DEMO]: isReadOnlyDemo(canWriteDemoDashboard, dashboard)
      });
      if (canSetDashboardPermissionValues) {
        showDialog({
          dialogType: DASHBOARD_SET_PERMISSION,
          dialogProps: {
            dashboardId,
            dashboardName: getName(dashboard),
            defaultSearchValue: contextParams.email,
            eventTracker: dashboardUITracker
          }
        });
        this.setState({
          setPermissionDialogIsOpen: true
        });
      }
    } else if (!isNil(dashboard) && ImmutableMap.isMap(dashboard) && dashboard.has('name') && !isValidDashboardString(getName(dashboard)) && canRenameDashboardValue && (!this.state || !this.state.forcedRenameIsOpen)) {
      showDialog({
        dialogType: DASHBOARD_RENAME,
        dialogProps: {
          dashboard,
          onRename: (name, renamedDashboardId) => {
            updateDashboardMeta(renamedDashboardId, {
              name
            });
          },
          trackAction: renamedDashboardId => dashboardUITracker(EVENTS.renameDashboard, {
            renamedDashboardId
          })
        }
      });
      this.setState({
        forcedRenameIsOpen: true
      });
    }
    if (!this.hasTrackedDashboardView && userAttributesLoaded && fetched) {
      this.hasTrackedDashboardView = true;
      dashboardUITracker(EVENTS.viewDashboard, {
        dashboardId,
        widgetCount: dashboard.get('widgetCount'),
        monthsSinceCreated: getMonthsSinceToday(getCreatedAt(dashboard)),
        monthsSinceUpdated: getMonthsSinceToday(getUpdatedAt(dashboard)),
        isDefaultDashboard: dashboardId === userAttributes.get(USER_ATTRIBUTES_KEYS.PREFERRED_HOME),
        template: getTemplate(dashboard)
      });
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener('online', this.updateDashboard);
  }
}
Dashboard.propTypes = {
  incrementForceRenderCount: PropTypes.func,
  dashboard: PropTypes.instanceOf(ImmutableMap),
  dashboardPermission: PropTypes.oneOf(AssetPermissionTypes),
  dashboardPermissionConfigStatus: PropTypes.string.isRequired,
  dashboards: PropTypes.instanceOf(ImmutableMap).isRequired,
  dashboardId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  report: PropTypes.instanceOf(ImmutableMap),
  dashboardLocked: PropTypes.bool,
  customReportCount: PropTypes.number,
  customDashboardCount: PropTypes.number,
  customDashboardLimit: PropTypes.number.isRequired,
  userAttributes: PropTypes.object.isRequired,
  userAttributesLoaded: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  fetched: PropTypes.bool,
  maxUserAssetPermission: PropTypes.oneOf(AssetPermissionTypes),
  canWriteDemoDashboard: PropTypes.bool,
  userId: PropTypes.number.isRequired,
  portalSettingsLoaded: PropTypes.bool.isRequired,
  fetchPermission: PropTypes.func.isRequired,
  initializeDashboardFilters: PropTypes.func.isRequired,
  owners: PropTypes.instanceOf(ImmutableMap),
  showDialog: PropTypes.func.isRequired,
  isFreeOrStarterUser: PropTypes.bool,
  contactCount: PropTypes.number,
  fetchContactCount: PropTypes.func,
  hasDashboardPanelAccess: PropTypes.bool
};
Dashboard.defaultProps = {
  customReportCount: undefined
};
export default compose(withRouter, withDialog, withDashboardPermission, connect((state, {
  dashboardId
}) => {
  return {
    dashboardPermission: selectDashboardPermission(dashboardId)(state),
    dashboardPermissionConfigStatus: selectDashboardPermissionConfigStatus(state),
    maxUserAssetPermission: selectUserMaxAssetPermission(state),
    canWriteDemoDashboard: selectHasDashboardDemoWriteScope(state),
    userId: selectUserId(state),
    isFreeOrStarterUser: selectIsFreeOrStarterUser(state),
    contactCount: selectContactCount(state),
    hasDashboardPanelAccess: selectHasDashboardPanelAccess(state)
  };
}, dispatch => ({
  incrementForceRenderCount: () => dispatch(INCREMENT_FORCE_RENDER_COUNT()),
  fetchPermission: (...args) => dispatch(fetchDashboardSentenceSingle(...args)),
  fetchContactCount: () => dispatch(getContactCount())
})), connectFlux({
  fetched: {
    stores: [DashboardStore],
    deref({
      dashboard
    }) {
      return dashboard != null && !!DashboardStore.get(['dashboardFetched', dashboard.get('id')]);
    }
  },
  customDashboardCount: DashboardCountDependency,
  customReportCount: CustomReportCountDependency,
  userAttributesLoaded: {
    stores: [SettingsStore],
    deref() {
      return SettingsStore.get('user-attributes-loaded');
    }
  },
  userAttributes: {
    stores: [SettingsStore],
    deref() {
      return SettingsStore.get('user-attributes');
    }
  },
  portalSettingsLoaded: {
    stores: [PortalSettingsStore],
    deref() {
      return PortalSettingsStore.get('loaded');
    }
  },
  widgetAlerts: {
    stores: [DashboardStore],
    deref() {
      return DashboardStore.get('widgetAlerts');
    }
  }
}))(Dashboard);